import React, { useMemo } from 'react';
import { ResponsiveAutocomplete } from '@/components/selects/ResponsiveAutocomplete';
import { useListAllBrokerGroupsQuery } from '../../brokerGroups/api/brokerGroupsApi';
import { getCountryName } from '../getCountryName';

/**
 * Pick countries: every distinct `countryCode` across broker groups (the stored country, or
 * else the config's), shown by full name.
 * value/onChange are country codes (an array when multiple, the default). Other props go
 * to ResponsiveAutocomplete.
 */
export const AdminCountryPicker = ({ multiple = true, ...props }) => {
	const { data: brokerGroups, isLoading } = useListAllBrokerGroupsQuery();

	const options = useMemo(
		() =>
			[...new Set((brokerGroups ?? []).map((brokerGroup) => brokerGroup.countryCode))]
				.filter(Boolean)
				.map((code) => ({ id: code, name: getCountryName(code) }))
				.sort((a, b) => a.name.localeCompare(b.name)),
		[brokerGroups],
	);

	return (
		<ResponsiveAutocomplete
			options={options}
			multiple={multiple}
			loading={isLoading}
			disabled={isLoading}
			{...props}
		/>
	);
};
